// src/pages/org-portal/components/OrgPortalBanner.jsx
import React from "react";

export default function OrgPortalBanner() {
    return (
        <section
            style={{
                marginBottom: 20,
                /* full-bleed: break out of any centered container */
                // width: "100vw",
                position: "relative",
                // left: "50%",
                // right: "50%",
                // marginLeft: "-50vw",
                // marginRight: "-50vw",
            }}
        >
            <img
                src="/dist/img/home-banner.png"
                alt="Players competing in a sports match"
                style={{
                    display: "block",     // remove inline gap
                    width: "100%",
                    height: "auto",      // keep aspect ratio
                    objectFit: "cover",  // safe if container height is ever constrained
                }}
            />
        </section>
    );
}